import { render } from "./GroupItem.vue?vue&type=template&id=4c8faab8"
import script from "./GroupItem.vue?vue&type=script&lang=js"
export * from "./GroupItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__